import { createAsyncActions } from '~/utils/store';

export const FETCHQTDD = createAsyncActions('@@LEADS/FETCHQTDD');
export const MOVE = createAsyncActions('@@LEADS/MOVE');
export const SAVE_METRICS = createAsyncActions('@@LEADS/METRICS');
export const LOAD_LEADS = createAsyncActions('@@LEADS/LOAD');
export const LOAD_MORE_LEADS = createAsyncActions('@@LEADS/LOAD_MORE_LEADS');

export const loadLeads = ({ ...params }) => ({
    type: LOAD_LEADS.INIT,
    payload: {
        request: {
            method: "GET",
            url: "/leads",
            ...params
        }
    }
});

export const loadMoreLeads = ({ columnId, currentCount, moreCount }) => ({
    type: LOAD_MORE_LEADS.INIT,
    payload: {
        request: {
            method: "GET",
            url: `/leads/more?stage=${columnId}&current_count=${currentCount}&more_count=${moreCount}`,
            columnId
        },
    },
})

export const fetchQtddByMonth = ({ date }) => ({
    type: FETCHQTDD.INIT,
    payload: {
        request:{
            method: 'get',
            url:`/leads/qtdd/${date}`
        }
      }
});

export const move = (props) => ({
    type: MOVE.INIT,
    payload: {
        request:{
            method: 'put',
            url:`/leads/${props[4]}/move`,
            data: {to: props[3].droppableId}
        },
    },
    props: props
});

export const saveMetrics = (data) => ({
    type: SAVE_METRICS.INIT,
    payload: {
        request: {
            method: 'post',
            url: '/leads/metrics',
            data
        }
    }
});